export enum Paths {
  Simulator = '/simulator/',
  Info = '/info',
}
